import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  crewInspectionCreateRequest,
  crewInspectionCreateSuccess,
  crewInspectionCreateFailure,
} = createActions({
  CREW_INSPECTION_CREATE_SUCCESS: json => json,
}, 'CREW_INSPECTION_CREATE_REQUEST', 'CREW_INSPECTION_CREATE_FAILURE');

export function crewInspectionCreate(crewInspectionData) {
  return (dispatch) => {
    dispatch(crewInspectionCreateRequest());
    return create('crew_inspection', crewInspectionData)
      .then(({ json }) => dispatch(crewInspectionCreateSuccess(json)))
      .catch(error => dispatch(crewInspectionCreateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/crew_inspection.js